import React from "react"
import PropTypes from "prop-types"

/**
 * Outlined paper-plane used by the AI Assistant's send button. Stroked (not filled) with a
 * visible fold line, matching the assistant's Figma — Ant Design's <SendOutlined /> is a solid
 * horizontal plane and reads differently at this size.
 *
 * Uses currentColor so it inherits the button's text color.
 */
export const SendPlane = ({ height = 20, width = 20, stroke = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M22 2L11 13"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 2L15 22L11 13L2 9L22 2Z"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

SendPlane.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  stroke: PropTypes.string
}

export default SendPlane
